import ProsesProduksiForm from '../ProsesProduksiForm';

export default function ProsesProduksiAdd() {
  return <ProsesProduksiForm mode="add" />;
}

